"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DraggableInsightListCore = void 0;
var tslib_1 = require("tslib");
// (C) 2022 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var sdk_model_1 = require("@gooddata/sdk-model");
var sdk_ui_kit_1 = require("@gooddata/sdk-ui-kit");
var insightList_1 = require("../../../insightList");
var DraggableInsightListItemWrapper_1 = require("./DraggableInsightListItemWrapper");
var model_1 = require("./../../../../model");
exports.DraggableInsightListCore = function (props) {
    var enableDescriptions = props.enableDescriptions, WrapInsightListItemWithDragComponent = props.WrapInsightListItemWithDragComponent, remainingProps = tslib_1.__rest(props, ["enableDescriptions", "WrapInsightListItemWithDragComponent"]);
    var userInteraction = model_1.useDashboardUserInteraction();
    return (react_1.default.createElement(insightList_1.InsightList, tslib_1.__assign({}, remainingProps, { renderItem: function (_a) {
            var _b;
            var insight = _a.item, width = _a.width, isFirst = _a.isFirst, isLast = _a.isLast;
            if (!insight) {
                return react_1.default.createElement(sdk_ui_kit_1.InsightListItem, { isLoading: true });
            }
            var visualizationUrl = sdk_model_1.insightVisualizationUrl(insight);
            var visualizationType = visualizationUrl === null || visualizationUrl === void 0 ? void 0 : visualizationUrl.split(":")[1];
            var classNames = classnames_1.default("gd-visualizations-list-item-wrap", {
                "is-first": isFirst,
                "is-last": isLast,
            });
            var description = (_b = sdk_model_1.insightSummary(insight)) === null || _b === void 0 ? void 0 : _b.trim();
            var eventPayload = {
                from: "insight",
                type: "inherit",
                description: description,
            };
            return (react_1.default.createElement(DraggableInsightListItemWrapper_1.DraggableInsightListItemWrapper, { WrapInsightListItemWithDragComponent: WrapInsightListItemWithDragComponent, title: sdk_model_1.insightTitle(insight), description: description, showDescriptionPanel: enableDescriptions, type: visualizationType, width: width, className: classNames, updated: sdk_model_1.insightUpdated(insight), isLocked: sdk_model_1.insightIsLocked(insight), insight: insight, onDescriptionPanelOpen: function () {
                    userInteraction.descriptionTooltipOpened(eventPayload);
                } }));
        } })));
};
//# sourceMappingURL=DraggableInsightListCore.js.map